import { ACCESSOIRES_GROUPS } from '@frontastic-engbers/helpers/constants/accessoiresGroups';
import { joinDiscounts } from '@frontastic-engbers/helpers/dataLayerHelper/couponCodeDataHelper';
import { DataLayerFactory } from '@frontastic-engbers/lib/lib/tracking/datalayerFactory';
import { Order } from '@frontastic-engbers/types/cart/Order';
import { AwinConfigResponse } from '@frontastic-engbers/types/engbers-custom';
import { ServerResponse } from 'http';
import { hasUCConsentForService } from './usercentrics';

const AWIN_UC_SERVICE_ID = 'SyfKc4oOjWQ';

export const setAwinCookie = (res: ServerResponse, awcParam: string | string[] | undefined) => {
  const awc = Array.isArray(awcParam) ? awcParam[0] : awcParam;

  if (awc) {
    res.setHeader(
      'Set-Cookie',
      `_awin_awc=${encodeURIComponent(awc)}; HttpOnly; Secure; Path=/; SameSite=Lax; Max-Age=${60 * 60 * 24 * 365}`
    );
  }
};

export const trackAwinConversionEvent = async () => {
  if (hasUCConsentForService(AWIN_UC_SERVICE_ID)) {
    await fetch('/api/tracking/awin', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }
};

export const buildAwinConversionTrackingUrl = (order: Order, awinConfig: AwinConfigResponse, cookies: Record<string, string>) => {
  const { merchantId, isTestMode, s2sTrackingUrl } = awinConfig;

  if (!merchantId || !s2sTrackingUrl) {
    throw new Error('Missing AWIN configuration: merchantId or s2sTrackingUrl');
  }

  const awc = cookies['_awin_awc'] || '';
  const channel = cookies['_awin_ch'] || '';

  const orderSubtotal = DataLayerFactory.convertCentAmount({
    currencyCode: order.sum.currencyCode,
    centAmount: order.lineItems?.reduce((price, item) => price + (item.totalPrice?.centAmount ?? 0), 0),
    fractionDigits: 2,
  }).toString();

  const affiliateGroup = order.lineItems?.some((lineItem) =>
    ACCESSOIRES_GROUPS.includes(lineItem.variant?.attributes?.ProductGroup),
  )
    ? 'ACCESSORIES'
    : 'SALE';

  const voucherCode = joinDiscounts(order.discountCodes, order.customLineItems);

  const params = new URLSearchParams({
    tt: 'ss',
    tv: '2',
    merchant: merchantId,
    amount: orderSubtotal,
    ch: channel,
    cr: order.sum.currencyCode,
    ref: order.orderId,
    parts: `${affiliateGroup}:${orderSubtotal}`,
    testmode: Number(isTestMode).toString(),
  });

  if (voucherCode) {
    params.append('vc', voucherCode);
  }

  if (awc) {
    params.append('cks', awc);
  }

  return `${s2sTrackingUrl}?${params.toString()}`;
};
